import { TFPageContent, TFPageHeader } from '@tf/shared';
import { T } from '@tf/utils';

import { appStore } from '@/core/stores';
import { AccountTable } from '@/components/accounts';
import { AddProfileButton } from '@/components/shared';

export const AccountListRoute = () => {
	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	return (
		<>
			<TFPageHeader tenant={tenant} title="Accounts" toolbar={<AddProfileButton />} />
			<TFPageContent>
				<AccountTable primaryActionNoDataState={<AddProfileButton />} />
			</TFPageContent>
		</>
	);
};
